module.exports = __webpack_public_path__ + "files/681173837d774ea09435f48ece3a528e.png";